/* eslint-disable react/no-danger */
import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector } from "react-redux";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormSelectOpcMappingType from "../../../../components/form/FormSelectOpcMappingType";
import CdoOpcMappingOpcCmdToMsg from "./CdoOpcMappingOpcCmdToMsg";
import CdoOpcMappingMsgToOpcCmd from "./CdoOpcMappingMsgToOpcCmd";
import CdoOpcMappingOpcCmdToSequence from "./CdoOpcMappingOpcCmdToSequence";
// INTERFACES
import { RootState } from "../../../../../app/store";
import {
  OpcMappingsInterface,
  OpcCmdToMessageInterface,
  MessageToOpcEntryInterface,
  OpcCmdToSequenceInterface,
  OpcMappingType,
} from "../../../../../interfaces/AdapterCdoOpc.interface";

export default function CdoOpcMapping({
  setValue,
  opcMapping,
}: {
  setValue: (newValue: any) => void;
  opcMapping: OpcMappingsInterface;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { theme } = useSelector((state: RootState) => state.home);
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [mappingType, setMappingType] = useState<OpcMappingType>("msg to opc cmd");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  const onChangeMappingType = (newValue: OpcMappingType) => {
    setMappingType(newValue);
  };

  const formatJsonWithColors = (obj: any) => {
    const json = JSON.stringify(obj, null, 4)
      .replace(/"([^"]+)"\s*:/g, '<span style="color:#9cdcfe;">"$1"</span>:')
      .replace(/: "([^"]*)"/g, ': <span style="color:#ce9178;">"$1"</span>')
      .replace(/:\s*(\d+)/g, ': <span style="color:#b5cea8;">$1</span>');
    return json;
  };

  const onClickRemoveOpcMapping = (index: number, type: string) => {
    const copy = structuredClone(opcMapping);
    if (type === "opc_command_to_message") {
      copy.opc_cmd_to_msg.splice(index, 1);
    } else if (type === "message_to_opc_command") {
      copy.msg_to_opc_cmd.splice(index, 1);
    } else if (type === "opc_command_to_sequence") {
      copy.opc_cmd_to_sequence.splice(index, 1);
    }
    setValue(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div className="container">
        <div className={`drawer__box__${theme} row`}>
          <div className="col-md-12 mt-3">
            <div className="generalStyles__flex">
              <span className="generalStyles__inputFlexRequired">*</span>
              <span className="drawer__text">OPC command to message</span>
            </div>
            <div className="generalStyles__width100">
              {opcMapping.opc_cmd_to_msg.map(
                (item: OpcCmdToMessageInterface, itemIndex: number) => (
                  <div
                    key={itemIndex}
                    className="mb-3"
                    style={{
                      backgroundColor: "#1f1f1f",
                      borderRadius: "5px",
                      fontSize: "9px",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <pre
                        style={{
                          width: "100%",
                          color: "#dcdcdc",
                          padding: "10px",
                          borderRadius: "8px",
                          overflowX: "auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: formatJsonWithColors(item),
                        }}
                      />
                      <div className="generalStyles__flexCenter">
                        <Tooltip title={t("general.delete")}>
                          <Button
                            onClick={() => {
                              onClickRemoveOpcMapping(itemIndex, "opc_command_to_message");
                            }}
                            className="buttonStyle__29"
                            shape="circle"
                            icon={<FontAwesomeIcon icon={faTrash} />}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="container">
        <div className={`drawer__box__${theme} row`}>
          <div className="col-md-12 mt-3">
            <div className="generalStyles__flex">
              <span className="generalStyles__inputFlexRequired">*</span>
              <span className="drawer__text">Message to OPC command</span>
            </div>
            <div className="generalStyles__width100">
              {opcMapping.msg_to_opc_cmd.map(
                (item: MessageToOpcEntryInterface, itemIndex: number) => (
                  <div
                    key={itemIndex}
                    className="mb-3 generalStyles__flex"
                    style={{
                      backgroundColor: "#1f1f1f",
                      borderRadius: "5px",
                      fontSize: "10px",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <pre
                        style={{
                          width: "100%",
                          color: "#dcdcdc",
                          padding: "10px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          overflowX: "auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: formatJsonWithColors(item),
                        }}
                      />
                    </div>
                    <div className="generalStyles__flexCenter" style={{ width: "50px" }}>
                      <Tooltip title={t("general.delete")}>
                        <Button
                          onClick={() => {
                            onClickRemoveOpcMapping(itemIndex, "message_to_opc_command");
                          }}
                          className="buttonStyle__29"
                          shape="circle"
                          icon={<FontAwesomeIcon icon={faTrash} />}
                        />
                      </Tooltip>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="container">
        <div className={`drawer__box__${theme} row`}>
          <div className="col-md-12 mt-3">
            <div className="generalStyles__flex">
              <span className="generalStyles__inputFlexRequired">*</span>
              <span className="drawer__text">OPC command to sequence</span>
            </div>
            <div className="generalStyles__width100">
              {opcMapping.opc_cmd_to_sequence.map(
                (item: OpcCmdToSequenceInterface, itemIndex: number) => (
                  <div
                    key={itemIndex}
                    className="mb-3 generalStyles__flex"
                    style={{
                      backgroundColor: "#1f1f1f",
                      borderRadius: "5px",
                      fontSize: "10px",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <pre
                        style={{
                          width: "100%",
                          color: "#dcdcdc",
                          padding: "10px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          overflowX: "auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: formatJsonWithColors(item),
                        }}
                      />
                    </div>
                    <div className="generalStyles__flexCenter" style={{ width: "50px" }}>
                      <Tooltip title={t("general.delete")}>
                        <Button
                          onClick={() => {
                            onClickRemoveOpcMapping(itemIndex, "opc_command_to_sequence");
                          }}
                          className="buttonStyle__29"
                          shape="circle"
                          icon={<FontAwesomeIcon icon={faTrash} />}
                        />
                      </Tooltip>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="container">
        <div className={`drawer__box__${theme} row`}>
          <FormSelectOpcMappingType
            inputValue={mappingType}
            inputOnChange={onChangeMappingType}
            disabledInput={false}
          />
          {/** OPC COMMAND TO MESSAGE */}
          {mappingType === "opc cmd to msg" && (
            <CdoOpcMappingOpcCmdToMsg setValue={setValue} opcMapping={opcMapping} />
          )}
          {/** MESSAGE TO OPC COMMAND */}
          {mappingType === "msg to opc cmd" && (
            <CdoOpcMappingMsgToOpcCmd setValue={setValue} opcMapping={opcMapping} />
          )}
          {/** OPC COMMAND TO SEQUENCE */}
          {mappingType === "opc cmd to sequence" && (
            <CdoOpcMappingOpcCmdToSequence setValue={setValue} opcMapping={opcMapping} />
          )}
        </div>
      </div>
      <br />
    </div>
  );
}
